export default "__VITE_ASSET__q_311s$o__"